import { useEffect } from "react";
import { useBlocker } from "react-router";

/** Protect dirty client-side work across browser unloads and SPA navigation. */
export function useUnsavedChangesGuard(active: boolean, message: string) {
  const blocker = useBlocker(active);

  useEffect(() => {
    if (!active) return;
    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [active]);

  useEffect(() => {
    if (blocker.state !== "blocked") return;
    if (window.confirm(message)) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker, message]);
}
